
import { createBrowserHistory } from 'history';
export const historyHelper = createBrowserHistory();